var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"color":"#3e154e","padless":""}},[_c('v-col',{staticClass:"text-center white--text ml-2"},[_vm._v(" ©"+_vm._s(new Date().getFullYear())+" "),_c('strong',[_vm._v(" Dtrips. All rights reserved")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }